(function () {
  var runtimeKey = '__thronePredictiveSearch';
  if (window[runtimeKey] && typeof window[runtimeKey].destroy === 'function') {
    window[runtimeKey].destroy();
  }

  var initialized = new WeakMap();
  var globalCleanups = [];
  var lastTrigger = null;

  function listen(target, type, handler) {
    target.addEventListener(type, handler);
    return function () { target.removeEventListener(type, handler); };
  }

  function getDialog() {
    return document.querySelector('[data-search-dialog]');
  }

  function closeMobileMenu() {
    var toggle = document.querySelector('[data-nav-toggle][aria-expanded="true"]');
    if (toggle) toggle.click();
  }

  function openDialog(trigger) {
    var dialog = getDialog();
    if (!dialog) return;
    lastTrigger = trigger || document.activeElement;
    closeMobileMenu();
    if (!dialog.open) dialog.showModal();
    var input = dialog.querySelector('input[type="search"]');
    if (input) {
      input.focus();
      input.select();
    }
  }

  function closeDialog() {
    var dialog = getDialog();
    if (dialog && dialog.open) dialog.close();
  }

  function initDialog(dialog) {
    if (initialized.has(dialog)) return;

    var input = dialog.querySelector('input[type="search"]');
    var results = dialog.querySelector('[data-search-results]');
    var close = dialog.querySelector('[data-search-close]');
    var clear = dialog.querySelector('[data-search-clear]');
    var predictiveUrl = dialog.getAttribute('data-predictive-url');
    var initialMarkup = results ? results.innerHTML : '';
    var timer = null;
    var controller = null;
    var options = [];
    var activeIndex = -1;
    var cleanups = [];

    if (!input || !results || !predictiveUrl) return;

    function setExpanded(expanded) {
      if (input) input.setAttribute('aria-expanded', String(expanded));
      if (!expanded && input) input.removeAttribute('aria-activedescendant');
    }

    function resetActive() {
      options.forEach(function (option) {
        option.classList.remove('is-active');
        option.setAttribute('aria-selected', 'false');
      });
      activeIndex = -1;
      if (input) input.removeAttribute('aria-activedescendant');
    }

    function collectOptions() {
      options = Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
      resetActive();
    }

    function activate(index) {
      if (!options.length) return;
      activeIndex = (index + options.length) % options.length;
      options.forEach(function (option, optionIndex) {
        var selected = optionIndex === activeIndex;
        option.classList.toggle('is-active', selected);
        option.setAttribute('aria-selected', String(selected));
      });
      input.setAttribute('aria-activedescendant', options[activeIndex].id);
      options[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function showStatus(message) {
      results.textContent = '';
      var status = document.createElement('p');
      status.className = 'search-dialog__status';
      status.textContent = message;
      results.appendChild(status);
      options = [];
      activeIndex = -1;
      setExpanded(true);
    }

    function resetResults() {
      if (controller) controller.abort();
      results.innerHTML = initialMarkup;
      options = [];
      activeIndex = -1;
      setExpanded(false);
    }

    function updateClear() {
      if (clear && input) clear.hidden = input.value.length === 0;
    }

    function fetchResults(term) {
      if (controller) controller.abort();
      controller = new AbortController();
      showStatus(dialog.getAttribute('data-loading-text'));

      var params = new URLSearchParams();
      params.set('q', term);
      params.set('resources[type]', 'article');
      params.set('resources[limit]', '8');
      params.set('section_id', 'predictive-search');

      fetch(predictiveUrl + '?' + params.toString(), {
        signal: controller.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(function (text) {
          var documentFragment = new DOMParser().parseFromString(text, 'text/html');
          var section = documentFragment.querySelector('#shopify-section-predictive-search');
          if (!section) throw new Error('missing-section');
          results.innerHTML = section.innerHTML;
          collectOptions();
          setExpanded(true);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          showStatus(dialog.getAttribute('data-error-text'));
        });
    }

    function handleClear() {
      input.value = '';
      updateClear();
      resetResults();
      input.focus({ preventScroll: true });
    }

    function handleDialogClick(event) {
      if (event.target === dialog) closeDialog();
    }

    function handleDialogClose() {
      resetActive();
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    }

    function handleInput() {
      window.clearTimeout(timer);
      updateClear();
      var term = input.value.trim();
      if (term.length < 2) {
        resetResults();
        return;
      }
      timer = window.setTimeout(function () { fetchResults(term); }, 200);
    }

    function handleInputKeydown(event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        activate(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        activate(activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        var link = options[activeIndex].querySelector('a');
        if (link) link.click();
      }
    }

    if (close) cleanups.push(listen(close, 'click', closeDialog));
    if (clear && input) {
      cleanups.push(listen(clear, 'click', handleClear));
    }
    cleanups.push(listen(dialog, 'click', handleDialogClick));
    cleanups.push(listen(dialog, 'close', handleDialogClose));

    cleanups.push(listen(input, 'input', handleInput));

    updateClear();

    cleanups.push(listen(input, 'keydown', handleInputKeydown));

    initialized.set(dialog, function () {
      window.clearTimeout(timer);
      if (controller) controller.abort();
      cleanups.forEach(function (cleanup) { cleanup(); });
      initialized.delete(dialog);
    });
  }

  function initAll(root) {
    root.querySelectorAll('[data-search-dialog]').forEach(initDialog);
  }

  function cleanupAll(root) {
    root.querySelectorAll('[data-search-dialog]').forEach(function (dialog) {
      var cleanup = initialized.get(dialog);
      if (cleanup) cleanup();
    });
  }

  function handleDocumentClick(event) {
    var trigger = event.target.closest('[data-search-open]');
    if (trigger) {
      event.preventDefault();
      openDialog(trigger);
    }
  }

  function handleDocumentKeydown(event) {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      openDialog(document.activeElement);
    }
  }

  function handleSectionLoad(event) {
    initAll(event.target);
  }

  function handleSectionUnload(event) {
    cleanupAll(event.target);
  }

  globalCleanups.push(listen(document, 'click', handleDocumentClick));
  globalCleanups.push(listen(document, 'keydown', handleDocumentKeydown));

  if (document.readyState === 'loading') {
    function handleReady() { initAll(document); }
    globalCleanups.push(listen(document, 'DOMContentLoaded', handleReady));
  } else {
    initAll(document);
  }

  globalCleanups.push(listen(document, 'shopify:section:load', handleSectionLoad));
  globalCleanups.push(listen(document, 'shopify:section:unload', handleSectionUnload));

  window[runtimeKey] = {
    destroy: function () {
      cleanupAll(document);
      globalCleanups.forEach(function (cleanup) { cleanup(); });
      globalCleanups = [];
      lastTrigger = null;
    }
  };
})();
